import styled, { css } from 'styled-components';

// COMPONENTS
import Button from '../Button/Button';

// CONSTANTS
import { theme } from '../../constants/theme';

interface InputUploadStyleProps {
  onClick?: any;
  disabled?: boolean;
  hasError?: boolean;
  isUploading?: boolean;
  viewDocument?: boolean;
}

export const InputUploadStyled = styled.div<InputUploadStyleProps>`
  display: flex;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  width: 100%;
  border: 1px solid ${theme.colors.secondary.gray500};
  border-radius: 8px;
  padding: 16px;
  min-height: 76px;

  @media (max-width: 1270px) {
    width: 95%;
  }
  
  ${({ disabled }) =>
    disabled &&
    css`
      background: ${theme.colors.primary.transparentBg};
    `}

  ${({ hasError }) =>
    hasError &&
    css`
      background: ${theme.colors.secondary.red600};
      border-color: ${theme.colors.secondary.red500};
    `}

	${({ isUploading }) =>
    isUploading &&
    css`
      background: ${theme.colors.secondary.blue600};
      border-color: ${theme.colors.secondary.blue500};
    `}
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  @media (max-width: 1270px) {
    flex-direction: column;
    button {
      margin-right: 0px;
    }
  }
`;

export const ButtonUpload = styled(Button)`
  padding: 8px 16px;
  position: relative;
  text-align: left;
  svg {
    position: absolute;
    right: 12px;
    margin-left: 22px;
  }
`;

export const Content = styled.div`
  flex-direction: column;
  margin: 0 16px;
  flex-wrap: wrap;
  width: auto;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;

  @media (max-width: 1270px) {
    padding-bottom: 10px;
  }
`;

export const ImageSvg = styled.div`
  width: 32px;
  height: 32px;
`;

export const Title = styled.div`
  flex-direction: column;
  font-weight: bold;
  font-size: 12px;
  width: 100%;
  color: ${theme.colors.primary.black};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 4px;
`;

export const Information = styled.div`
  display: flex;
`;

export const SubTitle = styled.div<InputUploadStyleProps>`
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  letter-spacing: 1%;
  color: ${theme.colors.secondary.gray200};

  ${({ hasError }) =>
    hasError &&
    css`
      color: ${theme.colors.secondary.red100};
    `}
`;

export const Size = styled.div`
  font-size: 12px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  letter-spacing: 1%;
  color: ${theme.colors.secondary.gray200};
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 16px;
`;

export const Circle = styled.div`
  background-color: ${theme.colors.secondary.gray200};
  height: 5px;
  width: 5px;
  border-radius: 50%;
  margin-left: 8px;
  margin-right: 8px;
  line-height: 16px;
`;

export const Upload = styled.input`
  display: none;
`;

export const SimpleLinkButton = styled.button<InputUploadStyleProps>`
  cursor: pointer;
  background: none;
  border: none;
  offset: none;
  width: auto;
  height: auto;

  ${({ viewDocument }) =>
    viewDocument &&
    css`
      margin-right: 16px;
    `}
`;

export const SimpleButton = styled.button<InputUploadStyleProps>`
  cursor: initial;
  background: none;
  border: none;
  offset: none;
  width: auto;
  height: auto;

  ${({ viewDocument }) =>
    viewDocument &&
    css`
      margin-right: 16px;
    `}
`;

export const SpanButton = styled.span`
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.colors.secondary.red100};

  svg {
    margin-left: 12px;
  }
`;

export const LoadingStyle = styled.div`
  display: flex;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  width: auto;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  color: ${theme.colors.primary.bariBlue};
  align-items: center;
`;

export const LoadingBar = styled.div`
  background: ${theme.colors.secondary.blue500};
  height: 4px;
  width: 90px;
  margin-left: 8px;
  margin-right: 16px;
  border-radius: 8px;
  overflow: hidden;
`;

export const LoadingBarComplete = styled.div`
  background: ${theme.colors.primary.bariBlue};
  width: 0%;
`;
